import { c as _c } from "react/compiler-runtime";
import { getOrgEntityStatusesQueryKey, patchOrgEntityStatusesBySlugMutation } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import type { VaultKind } from '@onefootprint/request-types';
import { Dialog, useConfirmationDialog } from '@onefootprint/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomStatusForm, { type CustomStatusFormData } from '../custom-status-form';
type CustomStatusAddDialogProps = {
  entityKind: VaultKind;
  open: boolean;
  onClose: () => void;
};
const CustomStatusAddDialog = t0 => {
  const $ = _c(34);
  const {
    entityKind,
    open,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "pages.statuses.customStatusAddEditDialog"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("settings", t1);
  const [isDirty, setIsDirty] = useState(false);
  const confirm = useConfirmationDialog();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = patchOrgEntityStatusesBySlugMutation();
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const addCustomStatusMutation = useMutation(t2);
  const showRequestErrorToast = useRequestErrorToast();
  const queryClient = useQueryClient();
  let t3;
  if ($[2] !== addCustomStatusMutation || $[3] !== onClose || $[4] !== queryClient || $[5] !== showRequestErrorToast) {
    t3 = async data => {
      ;
      try {
        await addCustomStatusMutation.mutateAsync({
          path: {
            slug: data.slug
          },
          body: {
            displayName: data.displayName,
            entityType: data.entityKind,
            entries: data.entries
          }
        });
        queryClient.invalidateQueries({
          queryKey: getOrgEntityStatusesQueryKey()
        });
        onClose();
      } catch (t4) {
        const error = t4;
        showRequestErrorToast(error);
      }
    };
    $[2] = addCustomStatusMutation;
    $[3] = onClose;
    $[4] = queryClient;
    $[5] = showRequestErrorToast;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleSave = t3;
  let t4;
  if ($[7] !== confirm || $[8] !== isDirty || $[9] !== onClose || $[10] !== t) {
    t4 = () => {
      if (!isDirty) {
        onClose();
        return;
      }
      confirm.open({
        title: t(_temp),
        description: t(_temp2),
        primaryButton: {
          label: t(_temp3),
          onClick: onClose
        },
        secondaryButton: {
          label: t(_temp4)
        }
      });
    };
    $[7] = confirm;
    $[8] = isDirty;
    $[9] = onClose;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleClose = t4;
  let t5;
  if ($[12] !== t) {
    t5 = t(_temp5);
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t(_temp6);
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== addCustomStatusMutation.isPending || $[17] !== t6) {
    t7 = {
      label: t6,
      type: "submit",
      form: "custom-status-add-edit-form",
      loading: addCustomStatusMutation.isPending
    };
    $[16] = addCustomStatusMutation.isPending;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t) {
    t8 = t(_temp7);
    $[19] = t;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== handleClose || $[22] !== t8) {
    t9 = {
      label: t8,
      onClick: handleClose
    };
    $[21] = handleClose;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== entityKind || $[25] !== handleSave) {
    t10 = <CustomStatusForm kind="add" entityKind={entityKind} onSubmit={handleSave} setDirty={setIsDirty} />;
    $[24] = entityKind;
    $[25] = handleSave;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== handleClose || $[28] !== open || $[29] !== t10 || $[30] !== t5 || $[31] !== t7 || $[32] !== t9) {
    t11 = <Dialog open={open} onClose={handleClose} title={t5} primaryButton={t7} secondaryButton={t9}>{t10}</Dialog>;
    $[27] = handleClose;
    $[28] = open;
    $[29] = t10;
    $[30] = t5;
    $[31] = t7;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
};
export default CustomStatusAddDialog;
function _temp($) {
  return $.form.closeConfirmation.title;
}
function _temp2($_0) {
  return $_0.form.closeConfirmation.description;
}
function _temp3($_1) {
  return $_1.form.discardChanges;
}
function _temp4($_2) {
  return $_2.form.cancel;
}
function _temp5($_3) {
  return $_3.title.add;
}
function _temp6($_4) {
  return $_4.form.save;
}
function _temp7($_5) {
  return $_5.form.cancel;
}